/**
 * GoogleCalendarCallback - Handles the OAuth redirect from Google
 *
 * Reads ?code= from URL, sends to backend, then redirects back to user panel.
 */
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { sendCalendarCallback } from '../services/api';

export default function GoogleCalendarCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('Conectando Google Calendar...');

  useEffect(() => {
    const code = searchParams.get('code');
    if (!code) {
      setStatus('Error: no se recibió código de autorización');
      setTimeout(() => navigate('/userpanel'), 3000);
      return;
    }

    (async () => {
      const result = await sendCalendarCallback(code);
      if (result.error) {
        setStatus(`Error: ${result.error}`);
      } else {
        setStatus('Google Calendar conectado exitosamente. Redirigiendo...');
      }
      setTimeout(() => navigate('/userpanel?calendarConnected=1'), 2000);
    })();
  }, [searchParams, navigate]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontFamily: "'Inter', sans-serif",
      color: '#333',
      textAlign: 'center',
      padding: '20px',
    }}>
      <div>
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>
          <i className="bi bi-calendar-check"></i>
        </div>
        <p style={{ fontSize: '16px' }}>{status}</p>
      </div>
    </div>
  );
}
